import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
export default class UserUnsuspendedNotification extends Notification {
  icon() {
    return 'fas fa-ban';
  }
  href() {
    return app.route.user(this.attrs.notification.subject());
  }
  content() {
    const notification = this.attrs.notification;
    return app.translator.trans('flarum-suspend.forum.notifications.user_unsuspended_text');
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('flarum-suspend', 'forum/components/UserUnsuspendedNotification', UserUnsuspendedNotification);